import { gql } from 'apollo-angular';

export const UPDATE_TIME_ENTRY_MUTATION = gql`
mutation updateTimeEntry($timeEntryInput: TimeEntryInput) {
  updateTimeEntry(timeEntryInput: $timeEntryInput) {
    id
  }
}
`;

export const CREATE_TIME_ENTRY_MUTATION = gql`
mutation createTimeEntry($timeEntryInput: TimeEntryInput) {
  createTimeEntry(timeEntryInput: $timeEntryInput) {
    id
  }
}
`;

export const DELETE_TIME_ENTRY_MUTATION = gql`
mutation deleteTimeEntry($timeEntryId: UUID) {
  deleteTimeEntry(timeEntryId: $timeEntryId)
}
`;

export const GET_TIME_ENTRIES_PAGED_QUERY = gql`
query getTimeEntriesPaged(
  $userId: UUID,
  $taskId: UUID,
  $ownerId: UUID,
  $ownerType: String,
  $aggregationRootId: UUID,
  $categoryId: UUID,
  $fromDateTime: String,
  $toDateTime: String,
  $pageNumber: Int,
  $pageSize: Int,
  $sortProperty: String,
  $sortDirection: String
) {
  getTimeEntriesPaged(
    filter: {
      userId: $userId,
      taskId: $taskId,
      ownerId: $ownerId,
      ownerType: $ownerType,
      aggregationRootId: $aggregationRootId,
      categoryId: $categoryId,
      fromDateTime: $fromDateTime,
      toDateTime: $toDateTime,
      sortRequest: {
        sortProperties: [$sortProperty],
        sortDirection: $sortDirection
      },
      pagination: {
        number: $pageNumber,
        size: $pageSize,
        sortProperty: $sortProperty,
        sortDirection: $sortDirection
      }
    }
  ) {
    totalPages
    totalElements
    number
    size
    content {
      id
      taskId
      startDateTime
      endDateTime
      duration
      pauseDuration
      note
      owner {
        id
        ownerType
        label
      }
      user {
        id
        firstName
        lastName
        email
      }
      category {
        id
        name
        externalId
        enabled
      }
      createdBy {
        id
        firstName
        lastName
      }
      createdDateTime
      lastModifiedDateTime
    }
  }
}
`;

export interface GetTimeEntriesPagedVariables {
  userId?: string;
  taskId?: string;
  ownerId?: string;
  ownerType?: string;
  aggregationRootId?: string;
  categoryId?: string;
  fromDateTime?: string;
  toDateTime?: string;
  pageNumber?: number;
  pageSize?: number;
  sortProperty?: string;
  sortDirection?: string;
}

export interface GetTimeEntriesPagedResponse {
  data: {
    getTimeEntriesPaged: {
      totalPages: number;
      totalElements: number;
      number: number;
      size: number;
      content: any[];
    };
  };
}

export const GET_TIME_ENTRY_CATEGORIES_SUM_QUERY = gql`
query getTimeEntryCategoriesSum(
  $userId: UUID,
  $taskId: UUID,
  $ownerId: UUID,
  $ownerType: String,
  $aggregationRootId: UUID,
  $categoryId: UUID,
  $fromDateTime: String,
  $toDateTime: String
) {
  getTimeEntryCategoriesSum(
    filter: {
      userId: $userId,
      taskId: $taskId,
      ownerId: $ownerId,
      ownerType: $ownerType,
      aggregationRootId: $aggregationRootId,
      categoryId: $categoryId,
      fromDateTime: $fromDateTime,
      toDateTime: $toDateTime
    }
  ) {
    category {
      id
      externalId
      name
      color
      enabled
    }
    sum
    count
  }
}
`;

export interface GetTimeEntryCategoriesSumVariables {
  userId?: string;
  taskId?: string;
  ownerId?: string;
  ownerType?: string;
  aggregationRootId?: string;
  categoryId?: string;
  fromDateTime?: string;
  toDateTime?: string;
}

export interface GetTimeEntryCategoriesSumResponse {
  data: {
    getTimeEntryCategoriesSum: any[];
  };
}
